import { render, staticRenderFns } from "./HelpCategoryModal.vue?vue&type=template&id=21ad3ce5&"
import script from "./HelpCategoryModal.vue?vue&type=script&lang=ts&"
export * from "./HelpCategoryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports